var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toolcool-color-picker',{staticClass:"tc_color_picker",attrs:{"id":_vm.id,"color":_vm.customColor,"popup-position":"right"}})
}
var staticRenderFns = []

export { render, staticRenderFns }